module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_navy.18092fb5.svg";